import MarkerClusterer from '@google/markerclusterer';

import View from '../../../Core/View.js';
import styleContainer from './mapStyle.json';

export default class Map extends View {

	static HEAD_LOCATION = 'Sloepdelen';

	initialize(options) {
		this.element = this.$el;
		this.routeData = options.routeData;

		this.config = {
			zoom: this._createValidZoomLevel(options.zoomLevel),
			center: this._createCenterPoint(options.centerPoint),
			mapTypeControl: false,
			styles: styleContainer,
			scrollwheel: false,
			streetViewControl: false,

		};
		this.legendPoints = options.legendPoints;
		this.allPositions = options.allPositions;
		this.seperatedMarkers = [];
		this.seperatedPoints = [];
		this._createValidObjectsArrays(this.legendPoints);
		this._pushCoordinatsIntoRightParent(this.allPositions)
		this._setup(this.element.get(0), this.config);

		this.onMarkerClick = options.onMarkerClick;

		this._pushFinalDataIntoMap();
	}

	getRouteColor() {
		return;
	}

	getGoogleMap() {
		return this.map;
	}

	_createCenterPoint(centerPointString) {
		const centerPointValidArray = centerPointString.split(' ');
		return {
			lat: parseFloat(centerPointValidArray[0]),
			lng: parseFloat(centerPointValidArray[1])
		}
	}

	_createValidZoomLevel(zoom) {
		return parseFloat(zoom);
	}

	_setup(element, configuration) {
		this.map = new google.maps.Map(element, configuration);
	}

	_createValidObjectsArrays(availableLegendPoints) {
		for (let legendName in availableLegendPoints) {
			if (legendName !== 'Untitled layer') {
				this.seperatedPoints[legendName] = [];
				this.seperatedMarkers[legendName] = [];
			}
		}
	}

	_pushCoordinatsIntoRightParent(positions) {
		for (let currentPosition in positions) {
			if (this._checkIfParentCategoryExists(currentPosition)) {
				this.seperatedPoints[positions[currentPosition]['type']].push(positions[currentPosition])
			}
		}
	}

	_checkIfParentCategoryExists(category) {
		return this.seperatedPoints.indexOf(category)
	}

	_assignMarkersToParent(key, allPoints) {
		for (var i = 0; i < allPoints[key].length; i ++) {
			this.seperatedMarkers[key].push(this._createMarker(key, allPoints[key][i]));
		}
	};

	_createOtherIcons(color) {
		let icon = {
			path: 'M0,128a128,128 0 1,0 256,0a128,128 0 1,0 -256,0',
			fillColor: '#' + color,
			fillOpacity: 1,
			strokeWeight: 0,
			scale: 0.1,

		};
		return icon;
	};

	_createSteigerIcon() {
		return {
			path: `M128,0C76.3,0,34.1,42.1,34.1,93.9c0,27.7,17.9,65.7,37.5,98.8c9.8,16.6,20,31.6,29.2,42.8
		c7.4,8.5,17.3,20.3,27.1,20.4c12.2-1.7,20.5-12.3,27.2-20.4c9.2-11.2,19.5-26.3,29.2-42.8c19.6-33.1,37.4-71.2,37.4-98.8
		C221.9,42.1,179.7,0,128,0z M135.1,47.3c-2.9,0.9-2.8,4.2-2.8,4.2l-1.5,31.9h5c1,0,1.9,0.9,1.9,1.9v0c0,1.1-0.9,1.9-1.9,1.9h-5.2
		l-0.3,5.5c4.2,1.1,7.3,4.9,7.3,9.4c0,4.5-3.1,8.3-7.3,9.4l0.3,5.5h5.2c1,0,1.9,0.8,1.9,1.9v0c0,1.1-0.9,1.9-1.9,1.9h-5l1.5,32.3
		c0,0-0.1,3.3,2.8,4.2c2.9,0.9,7.3-1,10.5-6.9c-1.6-0.6-3-1.1-3-1.1s-2.4-0.7,0.5-3.5c1.5-1.5,8-8.2,8.2-8.5
		c0.2-0.2,1.5-1.7,1.9,0.3c0,0,1.3,6.7,1.7,13.7c0.2,1.1-0.6,2-2.5,1.5c-1.8-0.5-2.3-0.6-2.3-0.6s-1.5,5.1-7.8,9.1
		c-6.4,3.9-10,5.8-11.1,7.2c-0.7,0.6-1.4,1.4-3.2,1.4c-1.8,0-2.5-0.8-3.2-1.4c-1.1-1.3-4.8-3.2-11.1-7.2c-6.4-3.9-7.8-9.1-7.8-9.1
		s-0.5,0.1-2.3,0.6c-1.8,0.5-2.6-0.4-2.5-1.5c0.3-7,1.7-13.7,1.7-13.7c0.5-2,1.7-0.5,1.9-0.3c0.2,0.2,6.6,7,8.2,8.5
		c2.9,2.8,0.5,3.5,0.5,3.5s-1.4,0.5-3,1.1c3.2,5.9,7.6,7.8,10.5,6.9c2.9-0.9,2.8-4.2,2.8-4.2l1.5-32.3h-5c-1.1,0-1.9-0.8-1.9-1.9v0
		c0-1.1,0.9-1.9,1.9-1.9h5.2l0.3-5.5c-4.2-1-7.3-4.8-7.3-9.4c0-4.5,3.1-8.3,7.3-9.4l-0.3-5.5h-5.2c-1.1,0-1.9-0.9-1.9-1.9v0
		c0-1,0.9-1.9,1.9-1.9h5l-1.5-31.9c0,0,0.1-3.3-2.8-4.2c-2.9-0.9-7.3,1-10.5,6.9c1.6,0.6,3,1.1,3,1.1s2.4,0.7-0.5,3.5
		c-1.5,1.5-8,8.2-8.2,8.5c-0.2,0.2-1.5,1.7-1.9-0.3c0,0-1.3-6.7-1.7-13.7c-0.2-1.1,0.6-2,2.5-1.5c1.8,0.5,2.3,0.6,2.3,0.6
		s1.5-5.1,7.8-9.1c6.4-3.9,10-5.8,11.1-7.1c0.7-0.6,1.4-1.4,3.2-1.4c1.8,0,2.5,0.8,3.2,1.4c1.1,1.3,4.8,3.2,11.1,7.1
		c6.4,3.9,7.8,9.1,7.8,9.1s0.5-0.1,2.3-0.6c1.8-0.5,2.6,0.4,2.5,1.5c-0.3,7-1.7,13.7-1.7,13.7c-0.5,2-1.7,0.5-1.9,0.3
		c-0.2-0.2-6.6-7-8.2-8.5c-2.9-2.8-0.5-3.5-0.5-3.5s1.4-0.5,3-1.1C142.4,48.3,138,46.4,135.1,47.3z`,
			fillColor: '#1C3664',
			fillOpacity: 1,
			strokeWeight: 0,
			scale: 0.2,
			anchor: new google.maps.Point(150, 160)
		};
	}

	_createGoogleClusterSvg(color) {
		const encoded = window.btoa(`<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px"
                   viewBox="0 0 256 256" style="enable-background:new 0 0 256 256;" xml:space="preserve">
                  <g fill="#${color}">
                      <circle cx="128" cy="128" r="128"/>
                     </g>
                   </svg>`);
		return (`data:image/svg+xml;base64,${encoded}`);

	}

	_createMarker(key, point) {
		const iconColor = this.legendPoints[key].color;
		const marker = new google.maps.Marker({
			position: point.coordinates,
			icon: this._decideIconType(point.type, iconColor)
		});

		marker.addListener('click', event => {
			this.onMarkerClick(point, marker);
		});
		return marker;
	};

	_decideIconType(placeName, color) {
		return placeName === Map.HEAD_LOCATION ? this._createSteigerIcon() : this._createOtherIcons(color)
	}

	_pushFinalDataIntoMap() {
		for (let key in this.seperatedPoints) {
			if (Array.isArray(this.seperatedPoints[key][0]['coordinates'])) {
				for (let i = 0; i < this.seperatedPoints[key].length; i ++) {
					this._createRoute(this.seperatedPoints[key][i], this.map)
				}
				continue;
			}
			this._assignMarkersToParent(key, this.seperatedPoints)
		}
		for (let key in this.seperatedMarkers) {
			this._pushNewCluster(key, this.map);
		}
	}

	_pushNewCluster(clusterName, map) {
		new MarkerClusterer(map, this.seperatedMarkers[clusterName], {
			styles: [
				{
					width: 40,
					height: 40,
					url: this._createGoogleClusterSvg(this.legendPoints[clusterName].color),
					textColor: 'white'
				}
			]
		})
	}

	_createRoute(settings, map) {
		if (this._mustRouteBeDisplayed() && this._routeMatchAssignedRoute(settings.headTitle)) {
			let sailPlanCoordinates = settings.coordinates;
			let sailPath = new google.maps.Polyline({
				path: sailPlanCoordinates,
				geodesic: true,
				strokeColor: '#' + settings.color,
				strokeOpacity: 1.0,
				strokeWeight: 2
			});
			sailPath.setMap(map);
		}
	}

	_mustRouteBeDisplayed() {
		return this.routeData !== '';
	}

	_routeMatchAssignedRoute(routeName) {
		return this.routeData === routeName;
	}
}


// WEBPACK FOOTER //
// ./js/Views/Modules/LocationMap/Map.js